<div>
  <!-- Header: título + X -->
  <div mat-dialog-title class="flex flex-row justify-between items-center p-4 bg-amazing_low rounded-t-2xl">
    <div class="text-2xl font-normal text-white">Empresas del Holding</div>
    <button class="bg-transparent text-white rounded-full hover:bg-white hover:text-amazing"
      mat-icon-button [mat-dialog-close]="undefined" matTooltip="Salir" tabindex="-1">
      <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>
  </div>

  <mat-dialog-content class="p-4 flex flex-row gap-4 items-start">
    <!-- Columna 1: Holding (todas las empresas del dominio) → Dashboard Holding ger/dbg-hol -->
    <div class="flex flex-col items-center shrink-0 w-40">
      <button type="button" (click)="select(TODAS)"
        class="flex flex-col items-center justify-center gap-2 w-40 h-40 p-3 rounded-xl border-2 cursor-pointer transition-colors bg-[#29AFD2] text-white hover:bg-[#2399B8]"
        [ngClass]="data.actual === TODAS ? 'border-amazing_drk' : 'border-[#29AFD2]'">
        <mat-icon class="icon-size-14 text-current" [svgIcon]="'heroicons_outline:building-office-2'"></mat-icon>
        <span class="text-md font-semibold text-center leading-tight">Holding</span>
      </button>
      @if (data.actual === TODAS) {
        <span class="mt-1 text-xs text-gray-500">Actual</span>
      }
    </div>

    <!-- Columna 2: empresas del dominio -->
    <div class="flex-auto min-w-0">
    <div class="dom-emp-grid h-8 z-10 sticky top-0 grid gap-4 py-2 px-6 shadow text-md font-normal text-white bg-amazing_low rounded">
      <div>Rut</div>
      <div>Nombre</div>
      <div></div>
    </div>

    <div class="max-h-96 overflow-y-auto">
      @for (emp of data.empresas; track emp.id) {
        <div class="dom-emp-grid grid items-center gap-4 h-10 px-6 border-b cursor-pointer"
          [ngClass]="emp.id === data.actual ? 'bg-gray-50 outline outline-2 -outline-offset-2 outline-amazing rounded' : 'bg-gray-50 hover:bg-amazing_vlo'"
          (click)="select(emp.id)">
          <div class="text-md font-semibold tabular-nums">{{ utils.frmRut(emp.rutt) }}</div>
          <div class="text-md font-semibold truncate">{{ emp.name }}</div>
          <div class="text-xs text-right">{{ emp.id === data.actual ? 'Actual' : '' }}</div>
        </div>
      } @empty {
        <div class="flex items-center justify-center h-24 text-gray-500">No se encontraron empresas</div>
      }
    </div>
    </div>
  </mat-dialog-content>
</div>
